import { render, staticRenderFns } from "./listRequestFriend.vue?vue&type=template&id=420a1b51"
import script from "./listRequestFriend.vue?vue&type=script&lang=js"
export * from "./listRequestFriend.vue?vue&type=script&lang=js"
import style0 from "./listRequestFriend.vue?vue&type=style&index=0&id=420a1b51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports